import { ArrowIcon, CheckIcon, LoaderIcon } from '@/components/Icons';
import './styles.scss';
import { type SignupCheckboxKey, useSignupForm } from './use-signup-form';

const SIGNUP_CHECKBOXES: { name: SignupCheckboxKey; label: string }[] = [
  {
    name: 'updates',
    label: 'I want to keep hearing about the PlayWall and receive updates',
  },
  {
    name: 'demo',
    label: 'I would like to see a demo',
  },
  {
    name: 'event',
    label: 'I am interested in using it for my upcoming campaign',
  },
];

export const SignupForm = ({
  inputRef,
}: {
  inputRef: React.RefObject<HTMLInputElement | null>;
}) => {
  const {
    isFocused,
    isSent,
    error,
    email,
    checkboxes,
    isPending,
    handleSubmit,
    handleChange,
    handleCheckboxChange,
    handleFocus,
    handleBlur,
    handleReset,
  } = useSignupForm();

  const disabled = isSent || isPending;

  return (
    <form onSubmit={handleSubmit} className='form'>
      <div className='signupCheckboxList' role='group' aria-label='Interests'>
        {SIGNUP_CHECKBOXES.map(({ name, label }) => (
          <label key={name} className='signupCheckbox'>
            <input
              type='checkbox'
              name={name}
              checked={checkboxes[name]}
              onChange={handleCheckboxChange}
              disabled={disabled}
            />
            <span className='signupCheckbox__control' aria-hidden>
              {checkboxes[name] ? <CheckIcon /> : null}
            </span>
            <span className='signupCheckbox__text'>{label}</span>
          </label>
        ))}
      </div>

      <label
        className={`emailInput ${isFocused ? 'focused' : ''} ${isSent ? 'sent' : ''}`}
      >
        <input
          type='text'
          name='email'
          value={email}
          placeholder={isFocused ? 'Type your email...' : 'Enter your email'}
          disabled={disabled}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          ref={inputRef}
        />
        {isSent ? (
          <button type='button' onClick={handleReset}>
            <CheckIcon />
          </button>
        ) : (
          <button type='submit' disabled={isPending}>
            {isPending ? <LoaderIcon /> : <ArrowIcon isFocused={isFocused} />}
          </button>
        )}
      </label>
      {error && <div className='error'>{error}</div>}
    </form>
  );
};

